import React from 'react';
import AuthorizedLayout from '../layouts/auth/AuthorizedLayout';
import { Location } from 'history';
import { Switch, Route, Redirect } from 'react-router';
import {
    AccountConfirmationPage,
    ProfilePage,
    NotFoundPage,
    ExamsInProcessingPage,
    ParticipationRequestsPage,
    ConnectedAscPage,
    ExpertQualificationsPage,
    ExpertCertificatePage,
    ExamListPage,
    RegistrationCompletionPage,
    EmailConfirmationPage,
    ConductRequestsListPage,
    ApplicantsPage,
    ApplicantDetailsPage,
    AccreditationCentersListPage,
    AscParticipatePage,
    ExpertChangeRequestsPage, AssignmentHistoryPage, AcDetailsPage, AscListPage,
} from '../pages';
import { ErrorBoundary } from 'components';
import ExpertsPage from '../pages/ExpertsPage/ExpertsPage';

interface AuthorizedHandlerProps {
    location: Location;
}

export default (props: AuthorizedHandlerProps) => {
    const { location } = props;
    return (
        <AuthorizedLayout location={location}>
            <React.Suspense fallback={<div>Loading...</div>}>
                <ErrorBoundary>
                    <Switch location={location}>
                        <Route path="/my-profile" component={ProfilePage} />

                        <Route exact path="/exam-list" component={ExamListPage} />
                        <Route path="/conduct-requests" component={ConductRequestsListPage} />
                        <Route path="/applicants" component={ApplicantsPage} />
                        <Route exact path="/applicant-details/:id/:tab" component={ApplicantDetailsPage} />
                        <Redirect path="/applicant-details/exam/:examId/:examApplicationId/" to="/applicant-details/exam/:examId/:examApplicationId/exam-details" />

                        <Route path="/change-requests" component={ExpertChangeRequestsPage} />
                        <Route path="/accreditation-centers" component={AccreditationCentersListPage} />
                        <Route path="/experts" component={ExpertsPage} />
                        <Route path="/asc" component={AscListPage} />
                        <Route path="/ac-details" component={AcDetailsPage} />
                        <Route path="/asc-participate" component={AscParticipatePage} />
                        <Route path="/assignment-history" component={AssignmentHistoryPage} />


                        <Route path="/exam-in-progress" component={ExamsInProcessingPage} />
                        <Route path="/participation-requests" component={ParticipationRequestsPage} />
                        <Route path="/connected-asc" component={ConnectedAscPage} />
                        <Route path="/expert-qualifications" component={ExpertQualificationsPage} />
                        <Route path="/expert-certificate" component={ExpertCertificatePage} />
                        <Route path="/registration-completion" component={RegistrationCompletionPage} />
                        <Redirect path="/exam-application-details/:id" to="/exam-application-details/:id/profile" />


                        <Route path="/confirm-email/:token/" component={EmailConfirmationPage} />
                        <Route path="/confirm/:token" component={AccountConfirmationPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </ErrorBoundary>
            </React.Suspense>
        </AuthorizedLayout>
    );
};
